// Mapper for Employee Basic (hierarchy-filtered list)
import { formatPersonName } from '@/utils';
import type {
  LC_EmployeeBasicItem,
  LC_EmployeeBasicData,
  EmployeeBasic,
  EmployeeBasicPage,
} from '../types/employeeBasic.types';


/**
 * Map LC_EmployeeBasicItem to EmployeeBasic domain model
 * El backend ya devuelve fullName como "ApellidoPaterno ApellidoMaterno Nombres";
 * aquí sólo se normaliza el caso.
 */
export function mapEmployeeBasicItem(item: LC_EmployeeBasicItem): EmployeeBasic {
  return {
    id: item.employeeId,
    fullName: formatPersonName(item.fullName ?? ''),
    rut: item.employeeTaxIdentificationNumber ?? '',
  };
}

/**
 * Map full paginated response to domain model
 * Backend returns: { data: [...], pagination: {...} }
 */
export function mapEmployeeBasicPage(response: LC_EmployeeBasicData): EmployeeBasicPage {
  const items = response.data || [];
  const pagination = response.pagination;
  
  return {
    items: items.map(mapEmployeeBasicItem),
    totalCount: pagination?.totalRecords || 0,
    page: pagination?.currentPage || 1,
    pageSize: pagination?.pageSize || 20,
    totalPages: pagination?.totalPages || 0,
    hasNextPage: pagination?.hasNextPage || false,
    hasPreviousPage: pagination?.hasPreviousPage || false,
  };
}
